export const stringsKey = "TemplateListDataGrid";
export const englishStrings = {
	title: "Name",
	countryName: "Country",
	batchMessageType: "Message Type",
	templateType: "Template Type",
	approximateCost: "Approximate Cost",
	status: "Status",
	action: "Action",
	editBtnTooltip: "Edit Template",
	approveBtnTooltip: "Approve Template",
	rejectBtnTooltip: "Reject Template",
	cancelTemplateBtnTooltip: "Cancel Template",
	previewBtnTooltip: "Preview Messages",
};
